import React, { useEffect, useState } from "react";
import {
  useLocation,
  useNavigate
} from "react-router-dom";
import { DistanceSearchItem, SearchListingsQuery } from "../models/search"
import { ListingCard } from "./listingCard"
import "./index.css"
import { Box, Button, CircularProgress, Grid2, Modal, Typography } from "@mui/material";
import Paginate from 'react-paginate'
import classnames from 'classnames'
import styles from './pagination.module.css'
import { Helmet } from "react-helmet";
import { useAuthRouting, useSignedInUserState } from "../hooks/useAuthState";
import { restaurantService } from "../services/firebase/restaurantManagementService";
import MapDialog, { Coordinates, HAS_VISITED, LOCAL_STORAGE_TTL_KEY } from "./dialog/mapDialog";
import { useLocalStorageLocation } from "../hooks/useLocationState";
import { LottieIndicator } from "../shared/lottieIndicator";
import CartPillButton from "../listingDetailsPage/cartPillButton";
import Lottie from "lottie-react";
import { viewHightMinusHeader } from "../header";
import { requestPermissionAndGetToken } from "../shared/messagesConsent";
import { FullProperty } from "../models/fullProperty";
import { MapsService } from "../services/functions/mapsService";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import {
  Utensils,
  ShoppingBag,
  Coffee,
  Beer,
  Pizza,
  IceCream2,
  Sandwich,
  Croissant,
  Soup,
  Store,
  LucideIcon
} from "lucide-react";
import ListingFilters from "./filter/ListingFilters";
import { CommentsClient } from "../services/functions/commentsClient";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "../firebase";

export type FilterOption = {
  label: string;
  icon: LucideIcon;
};

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function ListingSearchPage() {
  const location = useLocalStorageLocation();
  useAuthRouting()

  let user = useSignedInUserState()
  let query = useQuery();
  var searchQuery = SearchListingsQuery.transformFromQueryParams(query);
  const [pageNumber, setPageNumber] = useState(0);
  const [listings, setListings] = useState<DistanceSearchItem[]>([])
  const [pageCount, setPageCount] = useState<number>(0)
  const itemsPerPage = 20;
  const [openModal, setOpenModal] = useState(false);
  searchQuery.currentPage = pageNumber;
  const [loading, setLoading] = useState(true);
  console.log(pageCount)
  const LOCAL_STORAGE_KEY = "localLocation";
  const [locationUnavailable, setLocationUnavailable] = useState(false);
  const [animationData, setAnimationData] = useState<any>(null);
  const [nothingHereAnimationData, setNothingHereAnimationData] = useState<any>(null);
  const animationPath = "/animation/loading_location.json";
  const nothinHereAnimationPath = "/animation/nothing_here_animation.json";
  const [coordinates, setCoordinates] = useState<Coordinates | null>(null);
  const [showDistanceModal, setShowDistanceModal] = useState(false);
  const [activeListing, setActiveListing] = useState<FullProperty | null>(null)
  const [navigating, setIsNavigating] = useState(false);
  const pathLocation = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    handleOpenMap();
  }, []);


  const filterOptions: FilterOption[] = [
    { label: "Cafe", icon: Utensils },
    { label: "Pizza", icon: Pizza },
    { label: "Desserts", icon: IceCream2 },
    { label: "Burger", icon: Sandwich },
    { label: "Asian", icon: Soup },
    { label: "Bakery", icon: Croissant },
  ];

  useEffect(() => {
    if (user.profile) {
      requestPermissionAndGetToken(user.profile);
    }
  }, [user.profile]);

  useEffect(() => {
    fetch(animationPath)
      .then((response) => response.json())
      .then((data) => setAnimationData(data))
      .catch((error) => console.error("Error loading Lottie animation:", error));
  }, [animationPath]);

  useEffect(() => {
    fetch(nothinHereAnimationPath)
      .then((response) => response.json())
      .then((data) => setNothingHereAnimationData(data))
      .catch((error) => console.error("Error loading Lottie animation:", error));
  }, [nothinHereAnimationPath]);

  useEffect(() => {
    if (location) {
      handleGetRestaurantsFromLocation();
    }
  }, [location]);

  useEffect(() => {
    setIsNavigating(false);
  }, [pathLocation]);

  const handleOpenMap = async () => {
    setLoading(true)
    const hasVisited = localStorage.getItem(HAS_VISITED);
    const locationExpiresAt = localStorage.getItem(LOCAL_STORAGE_TTL_KEY);

    if (hasVisited !== "true" || locationExpiresAt == null || new Date() > new Date(locationExpiresAt)) {
      setOpenModal(true);
    } else {
      handleGetRestaurantsFromLocation();
      setLoading(false)
    }
  }


  const handleGetRestaurantsFromLocation = async () => {
    setLoading(true)
    if (coordinates != null && coordinates?.lat != null && coordinates?.lng != null) {
      const listings = await restaurantService.searchRestaurantsByProximity(coordinates?.lat, coordinates?.lng)
      setListings(listings);
      setPageCount(Math.ceil(listings.length / itemsPerPage));
    } else {
      const listings = await restaurantService.searchRestaurantsByProximity(0, 0)
      setListings(listings);
      setPageCount(Math.ceil(listings.length / itemsPerPage));
    }
    setLoading(false)

  }

    const handleFilterChange = (selected: string) => {
    setListings((prev) => restaurantService.sortRestaurants(prev, selected));
  };


  // Invoke when user click to request another page.
  const handlePageClick = (event: any) => {
    const newPageNumber = event.selected;
    console.log(
      `User requested page number ${newPageNumber}`
    );
    console.log(listings)
    setPageNumber(newPageNumber);
  };

  const renderEmptyState = (title: string, message: string) => (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 2,
        padding: 4,
      }}
    >
      <Typography variant="h6" sx={{ color: "#162C1F" }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ color: "#555" }}>
        {message}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignContent: "center",
          gap: 5,
        }}
      >
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: "8px 16px",
            borderRadius: "5px",
            backgroundColor: "#162C1F",
            color: "#fff",
            border: "none",
          }}
        >
          Refresh Page
        </button>
        <button
          onClick={() => setOpenModal(true)}
          style={{
            padding: "8px 16px",
            borderRadius: "5px",
            backgroundColor: "#162C1F",
            color: "#fff",
            border: "none",
          }}
        >
          Update Location
        </button>
      </Box>
    </Box>
  );

  // Close the modal
  const handleCloseModal = async () => {
    if (coordinates != null && coordinates?.lat != null && coordinates?.lng != null) {
      await handleGetRestaurantsFromLocation();
    } else {
      setLocationUnavailable(true);
    }
    setOpenModal(false);
  };


  // Close the modal
  const onConfirm = async (coords: Coordinates) => {
    setCoordinates(coords);
    await handleGetRestaurantsFromLocation();
    setLocationUnavailable(false);
    setOpenModal(false);
  };

  const getStoredCoordinates = (): Coordinates | null => {
    const storedLocation = localStorage.getItem(LOCAL_STORAGE_KEY);

    if (storedLocation) {
      const parsedLocation = JSON.parse(storedLocation);

      // Ensure it matches the Coordinates structure
      return {
        lat: parsedLocation.lat,
        lng: parsedLocation.lng,
      };
    }

    return null;
  };

  const handleCardClick = (listing: FullProperty) => {
    const dist = MapsService.distance(listing.location.lat, listing.location.lng, getStoredCoordinates()?.lat ?? 0.0, getStoredCoordinates()?.lng ?? 0.0);
    if (parseFloat(dist) > 30) {
      setActiveListing(listing)
      setShowDistanceModal(true);
    } else {
      setIsNavigating(true);
      navigate(`/listing/${listing.id}`);
    }
  };

  if (navigating) {
    return (
      <div className="patlite">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: 4,
              borderRadius: 3,
              boxShadow: 3,
              backgroundColor: 'white',
              minWidth: 320,
              maxWidth: 400,
              textAlign: 'center',
            }}
          >
            <CircularProgress sx={{ color: '#162C1F', mb: 2 }} />
            <Box sx={{ fontSize: 18, fontWeight: 600, color: '#162C1F', mb: 1 }}>
              Fetching details...
            </Box>
            <Box sx={{ fontSize: 14, color: '#555' }}>
              We're loading surplus meals and sustainable offers just for you.
            </Box>
          </Box>
        </Box>
      </div>
    );
  }
  return (
    <div className={"patlite"}>
      <Helmet>
        <title>Eco Eats | Search Our Great Deals</title>
        <meta name="description" content="Eco Eats: Search restaurants near you" />
        {/* <!-- Open Graph Tags --> */}
        <meta property="og:title" content="Eco Eats - Save Food. Save Money. Save the Planet." />
        <meta property="og:description" content="Eco Eats helps you rescue delicious surplus meals from local restaurants. Eat well, spend less, and fight food waste near you." />
        <meta property="og:image" content="./src_assets/drawer_logo.svg" />

        {/* <!-- Twitter Card Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Eco Eats - Save Food. Save Money. Save the Planet." />
        <meta name="twitter:description" content="Eco Eats helps you rescue delicious surplus meals from local restaurants. Eat well, spend less, and fight food waste near you." />
        <meta name="twitter:image" content="./src_assets/drawer_logo.svg" />
      </Helmet>
      <MapDialog open={openModal} onClose={handleCloseModal} onConfirm={onConfirm} user={user} />
      <div className=" patlite">
      </div>
      <Box className="ListingSearchPage" sx={{ minHeight: viewHightMinusHeader }}>
        <Box className="ListingCardColumn" sx={{ width: "100%" }}>
          {(loading && !locationUnavailable) && (
            <Box
              sx={{
                height: viewHightMinusHeader,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  backgroundColor: "white",
                  borderRadius: 2,
                  padding: 2,
                  boxShadow: 3,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  height: 300,
                }}
              >
                <Lottie
                  animationData={animationData}
                  style={{ height: 150 }}
                />
                <Typography textAlign="center" variant={"subtitle2"}>
                  Finding eco-conscious options nearby... 🍃
                </Typography>
              </Box>
            </Box>
          )}

          {(!loading && locationUnavailable) && (
            renderEmptyState(
              "Location not available",
              "Please update your location to find restaurants near you."
            )
          )}
          <ListingFilters
            filters={filterOptions}
            onFilterChange={handleFilterChange}
          />
          {(!loading && !locationUnavailable && listings.length > 0) && (
            <Grid2
              container                // ← mark this as the container
              spacing={2}
              justifyContent="center"
              sx={{ px: 2, pb: 2 }}
            >

              {listings.map((l) => (
                <Grid2
                  key={l.restaurant.id}
                  // if only one card, take up more of the row
                  maxWidth={"400px"}
                  size={{
                    xs: 12,
                    sm: listings.length === 1 ? 12 : 8,
                    md: listings.length === 1 ? 12 : 8,
                    lg: listings.length === 1 ? 12 : 8,
                    xl: listings.length === 1 ? 12 : 8
                  }}
                >
                  <ListingCard
                    listing={l.restaurant}
                    onCardClick={handleCardClick}
                  />
                </Grid2>
              ))}
            </Grid2>
          )}

          {(!loading && !locationUnavailable && listings.length === 0) && (
            <LottieIndicator
              data={nothingHereAnimationData}
              message="Sorry There Are No Restaurants Available Please Try Again Later"
            />
          )}

          <CartPillButton />
        </Box>
      </Box>
      {!loading && pageCount > 1 && (
        <div className={classnames('issuesPagination', styles.pagination)}>
          <Paginate
            onPageChange={handlePageClick}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={20}
            forcePage={pageNumber}
            nextLabel="&rarr;"
            previousLabel="&larr;"
          />
        </div>
      )}

      <Modal
        open={showDistanceModal}
        onClose={() => setShowDistanceModal(false)}
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 4,
            p: 4,
            width: 200,
            textAlign: "center",
          }}
        >
          <LocationOnIcon color="primary" sx={{ fontSize: 48, mb: 2, color: "#162C1F" }} />
          <Typography variant="subtitle2" component="h2" sx={{ mb: 3 }}>
            This restaurant is more than 30km away. Are you sure you would like to proceed?
          </Typography>

          <Box display="flex" gap={2} justifyContent="center">
            <Button
              sx={{ margin: "0 8px", border: "1px solid #162C1F", borderRadius: "24px" }}
              variant="outlined"
              color="secondary"
              onClick={() => setShowDistanceModal(false)}
            >
              <Typography variant="button" component="h1" sx={{ color: "#162C1F" }}>
                Cancel
              </Typography>
            </Button>
            <Button
              variant="contained"
              sx={{ margin: "0 8px", background: "#162C1F", border: "1px solid #162C1F", borderRadius: "24px" }}
              color="primary"
              onClick={() => {
                if (activeListing) {
                  window.location.href = "/listing/" + activeListing.id;
                }
              }}
            >
              Proceed
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default ListingSearchPage;